import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
const products = [{
  id: 1,
  name: 'Custom Ceramics',
  description: 'Trinket dishes, mugs, and decorative pieces featuring your artwork',
  image: 'https://images.unsplash.com/photo-1565193566173-7a0ee3dbe261?w=800&h=600&fit=crop',
  color: 'from-amber-500/20 to-orange-500/20'
}, {
  id: 2,
  name: 'Premium Journals',
  description: 'Archival-quality notebooks with custom covers and lined pages',
  image: 'https://images.unsplash.com/photo-1544816155-12df9643f363?w=800&h=600&fit=crop',
  color: 'from-emerald-500/20 to-teal-500/20'
}, {
  id: 3,
  name: 'Art Prints & Posters',
  description: 'Giclée prints on museum-grade paper with vibrant color reproduction',
  image: 'https://images.unsplash.com/photo-1579783902614-a3fb3927b6a5?w=800&h=600&fit=crop',
  color: 'from-violet-500/20 to-purple-500/20'
}, {
  id: 4,
  name: 'Apparel & Totes',
  description: 'Custom printed t-shirts, tote bags, and accessories',
  image: 'https://images.unsplash.com/photo-1622560480605-d83c853bc5c3?w=800&h=600&fit=crop',
  color: 'from-rose-500/20 to-pink-500/20'
}];
export function ProductShowcase() {
  return <section className="py-24 bg-museum-gray" data-id="element-227">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-228">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6" data-id="element-229">
          <div data-id="element-230">
            <h2 className="text-4xl md:text-5xl font-serif font-bold text-museum-black tracking-tight mb-4" data-id="element-231">
              Custom Products
            </h2>
            <p className="text-xl text-museum-subtle max-w-xl" data-id="element-232">
              Transform your institution's artwork into premium merchandise with
              low minimums and fast turnaround.
            </p>
          </div>
          <a href="#" className="inline-flex items-center text-museum-blue font-semibold hover:text-museum-dark transition-colors group" data-id="element-233">
            View All Products
            <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-234" />
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-235">
          {products.map((product, index) => <motion.a key={product.id} href="#" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="group relative overflow-hidden rounded-3xl bg-white shadow-lg hover:shadow-2xl transition-all duration-500" data-id="element-236">
              {/* Image */}
              <div className="aspect-[4/3] overflow-hidden" data-id="element-237">
                <img src={product.image} alt={product.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-238" />
                {/* Gradient overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/0 to-transparent" data-id="element-239"></div>
              </div>

              {/* Content overlay */}
              <div className="absolute bottom-0 left-0 right-0 p-8" data-id="element-240">
                <h3 className="text-2xl font-serif font-bold text-white mb-2" data-id="element-241">
                  {product.name}
                </h3>
                <p className="text-white/80 text-sm mb-4" data-id="element-242">
                  {product.description}
                </p>
                <span className="inline-flex items-center text-white text-sm font-semibold group-hover:underline" data-id="element-243">
                  Explore
                  <ArrowRight className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" data-id="element-244" />
                </span>
              </div>
            </motion.a>)}
        </div>
      </div>
    </section>;
}